<template>
  <a-spin tip="数据加载中..." :spinning="loading">
    <div
      id="userChart"
      :loading="true"
      style="height: 300px;width: 400px"
    ></div>
  </a-spin>
</template>

<script>
import * as echarts from "echarts";
import { user_chart } from "@/api/blog";

export default {
  name: "dailyIncrease",
  props: {
    blogId: null,
    dateRange: null,
  },
  data() {
    return {
      chart: null,
      loading: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getData();
    });
  },
  watch: {
    dateRange() {
      this.getData();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById("userChart"));

    window.onresize = () => {
      // 重新绘制
      this.chart.resize();
    };
  },
  methods: {
    createChart(refDate, newUser, cancelUser, cleanUser) {
      // 绘制图表
      this.chart.setOption({
        title: false,
        tooltip: { trigger: "axis" },
        legend: {
          data: ["净增", "关注", "取关"],
          selected: { 关注: false, 取关: false },
        },
        grid: { left: "3%", right: "4%", bottom: "3%", containLabel: true },
        xAxis: { type: "category", boundaryGap: false, data: refDate },
        yAxis: { type: "value" },
        series: [
          {
            name: "净增",
            type: "line",
            stack: "总量",
            smooth: true,
            data: cleanUser,
          },
          {
            name: "关注",
            type: "line",
            stack: "总量2",
            smooth: true,
            data: newUser,
          },
          {
            name: "取关",
            type: "line",
            stack: "总量3",
            smooth: true,
            data: cancelUser,
          },
        ],
      });
      this.chart.resize();
    },
    getData() {
      this.loading = true;

      // 用户 chart
      user_chart({ id: this.blogId, time_range: this.dateRange }).then(
        (res) => {
          this.loading = false;
          if (res.code === 1) {
            this.createChart(
              res.list.ref_date,
              res.list.new_user,
              res.list.cancel_user,
              res.list.clean_user
            );
          } else {
            this.$message.warning(res.msg);
          }
        }
      );
    },
  },
};
</script>

<style scoped></style>
